import * as React from "react";
import { useDisclosure } from "@chakra-ui/react";

type NavContextType = {
  openNavWithSection: (sectionIndex: number) => void;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  expandedSections: number[];
  setExpandedSections: (sections: number[]) => void;
  currentUnitId: string | null;
  setCurrentUnitId: (unitId: string | null) => void;
};

export const NavContext = React.createContext<NavContextType | null>(null);

export const useNav = () => {
  const context = React.useContext(NavContext);
  if (!context) {
    throw new Error("useNav must be used within NavProvider");
  }
  return context;
};

export const NavProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [expandedSections, setExpandedSections] = React.useState<number[]>([]);
  const [currentUnitId, setCurrentUnitId] = React.useState<string | null>(null);

  const openNavWithSection = React.useCallback(
    (sectionIndex: number) => {
      setExpandedSections([sectionIndex]);
      onOpen();
    },
    [onOpen],
  );

  return (
    <NavContext.Provider
      value={{
        openNavWithSection,
        isOpen,
        onOpen,
        onClose,
        expandedSections,
        setExpandedSections,
        currentUnitId,
        setCurrentUnitId,
      }}
    >
      {children}
    </NavContext.Provider>
  );
};
